import { t } from '@/i18n';
import { z } from 'zod';

export const modalFormSchema = z.object({
  year: z.preprocess(
    value => (typeof value === 'string' ? parseInt(value, 10) : value),
    z.number().gte(1500, t('pages.application_won_title.components.won_title_edit_modal.schema.required_number')),
  ),
  competition_uuid: z.string().min(1, t('pages.application_won_title.components.won_title_edit_modal.schema.required')),
  team_uuid: z.string().optional(),
});

export type ModalFormData = z.infer<typeof modalFormSchema>;
